import { Stack, Title } from "@skailer-com/uikit";
import { ReactNode } from "react";

interface ConfigureSectionProps {
  label: string;
  children: ReactNode;
}

export function ConfigureSection({ label, children }: ConfigureSectionProps) {
  return (
    <Stack gap="xs">
      <Title header={label} size="xs" className="pl-2" />
      {children}
    </Stack>
  );
}
